import { AfterViewInit, Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { BehaviorSubject, filter, map } from 'rxjs';
import { ExternalDataService } from '../../services/external-data/external-data.service';
import { GoogleComposerService } from '../../services/google-pay/google-composer.service';
import { GooglePayService } from '../../services/google-pay/google-pay.service';

@Component({
  selector: 'app-google-pay',
  imports: [],
  templateUrl: './google-pay.component.html',
  styleUrl: './google-pay.component.scss',
})
export class GooglePayComponent implements AfterViewInit {
  private readonly AVAILABLE_STYLES = ["black", "white"];
  
  @ViewChild('gpcontainer') container!: ElementRef;

  public $style = new BehaviorSubject<string>("black");
  
  private button?: HTMLElement;

  constructor(
    private renderer: Renderer2,
    private googlePayService: GooglePayService,
    private googleComposer: GoogleComposerService,
    private externalDataService: ExternalDataService
  ) {
    this.externalDataService.$googleButtonstyle
      .pipe(map(style => style.toLowerCase()))
      .pipe(filter(style => this.AVAILABLE_STYLES.includes(style)))
      .pipe(filter(style => this.$style.getValue() != style))
      .subscribe((gbs) => (this.$style.next(gbs)));
  }

  ngAfterViewInit(): void {
    this.$style.subscribe((style) => this.addButton(style));
  }

  private addButton(style: string) {
    if (this.button) {
      this.renderer.removeChild(this.container.nativeElement, this.button);
      this.button = undefined;
    }

    const button = this.googlePayService.paymentsClient.createButton({
      onClick: () => this.googlePayService.pay(),
      allowedPaymentMethods: [this.googleComposer.baseCardPaymentMethod],
      buttonSizeMode: 'fill',
      buttonType: 'plain',
      buttonLocale: 'en',
      // @ts-expect-error -> We filter out the incorrect strings anyway - typechecker does not know that.
      buttonColor: style.toLowerCase(),
    });

    this.renderer.appendChild(this.container.nativeElement, button);
    this.button = button;
  }
}
